import { createI18n } from "vue-i18n";
import {
  DEFAULT_LANGUAGE,
  FALLBACK_LANGUAGE,
  SUPPORTED_LANGUAGES,
} from "./trans";
import en from "./en.json";
import az from "./az.json";
import ru from "./ru.json";
import tr from "./tr.json";

const getSavedLocale = () => {
  const saved = localStorage.getItem("app_language");
  if (saved && SUPPORTED_LANGUAGES.includes(saved)) {
    return saved;
  }
  return DEFAULT_LANGUAGE;
};

/**
 * Production CSP forbids `unsafe-eval`. vue-i18n's default compiler uses
 * `new Function(...)`. In legacy mode the `messageCompiler` option is also
 * stripped by convertComposerOptions, so plain string messages always hit eval.
 *
 * Pre-wrap every string as a MessageFunction so compilation is skipped.
 */
function asMessageFunctions(dict) {
  const out = Object.create(null);
  Object.keys(dict).forEach((key) => {
    const value = dict[key];
    out[key] = typeof value === "string" ? () => value : value;
  });
  return out;
}

export const i18n = createI18n({
  legacy: true,
  globalInjection: true,
  locale: getSavedLocale(),
  fallbackLocale: FALLBACK_LANGUAGE,
  messages: {
    en: asMessageFunctions(en),
    az: asMessageFunctions(az),
    ru: asMessageFunctions(ru),
    tr: asMessageFunctions(tr),
  },
  silentFallbackWarn: true,
  silentTranslationWarn: true,
});

export const changeLanguage = (locale) => {
  if (SUPPORTED_LANGUAGES.includes(locale)) {
    i18n.global.locale = locale;
    localStorage.setItem("app_language", locale);
  }
};
